export function fetchData(query) {
  return fetch(process.env.VUE_APP_FIVB_API_URL, {
    method: "POST",
    mode: "cors",
    cache: "no-store",
    headers: new Headers({
      "Content-Type": "application/xml",
      Accept: "application/json",
      "X-FIVB-App-ID": "3b665ad61056495ab5514b81eb0562d8"
    }),
    body: query
  }).then(response => response.json());
}



// WEBPACK FOOTER //
// ./src/service.js